import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import { APP_FILE_NOTICES_LIST } from "./notices.constants";

const NoticesList = Loadable(
  lazy(() =>
    import("./EdocNoticesTabs").then(({ EdocNoticesTabs }) => ({
      default: EdocNoticesTabs,
    }))
  )
);
export const noticesRoutes = [
   {
          path: `${APP_FILE_NOTICES_LIST}`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[MODULE_IDS.TASK_NOTICES]}>
              <NoticesList />
            </AuthorizedRoute>
          ),
        },
];
